export { default, useAccess } from "./useFunctionAccess";
